export default "/images/auth_layer_bg.svg?8f2678edcb61470b5c573f11db4d5ef7";